const ServerDateMixin = {
	methods: {
		getServerDate(){ 
            var serverDate = this.$store.getters.GET_SERVER_DATE ? this.$store.getters.GET_SERVER_DATE.payload : null
            return serverDate || new Date()
        },
	},
};

module.exports = ServerDateMixin;